import axios from "axios";
import { API } from "../config";

axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.put['Access-Control-Allow-Origin'] = '*';

const path = "/servico-acolhimento";
const subPath = "/familia-acolhedora";

class FamiliaAcolhedoraSAService {
  novaFamiliaAcolhedoraSA(id, familiaAcolhedoraSA) {
    return axios.post(API + path + `/${id}` + subPath, familiaAcolhedoraSA);
  }

  getFamiliasAcolhedorasSA(id) {
    return axios.get(API + path + `/${id}` + subPath)
  }

  getFamiliaAcolhedoraCPF = (idSA, cpf) => {
    return axios.get(API + path + `/${idSA}` + subPath + `/acolhedor?numeroDocumento=${cpf}`, {
      headers: {
        'numeroDocumento': cpf
      }
    });
  };

  getFamiliaAcolhedoraCPFCrianca = (idSA, cpf, idCrianca) => {
    return axios.get(API + path + `/${idSA}` + subPath + `/crianca/${idCrianca}?numeroDocumento=${cpf}`, {
      headers: {
        'numeroDocumento': cpf
      }
    });
  };

  getFamiliaAcolhedoraTermoGuarda = (idSA, cpfAcolhedor, idCrianca) => {
    return axios.get(API + path + `/${idSA}` + subPath + `/termo-guarda?idCrianca=${idCrianca}&numeroDocumento=${cpfAcolhedor}`, {
      headers: {
        'numeroDocumento': cpfAcolhedor
      },
    });
  };

  postFamiliaAcolhedoraTermoGuarda(idSA, idCrianca, anexo, timestampValidadeTermoGuarda, xDocumentNumber) {
    var formData = new FormData();
    formData.append('anexo', anexo);

    return axios.post(API + path + `/${idSA}` + subPath + `/acolhedor/crianca/${idCrianca}/termo-guarda?timestampValidadeTermoGuarda=${timestampValidadeTermoGuarda}`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-document-number': `${xDocumentNumber}`
        }
      }
    );
  }

  atualizarFamiliaAcolhedoraSA(id, idSA, familiaAcolhedoraSA) {
    return axios.put(API + path + `/${idSA}` + subPath + `/${id}`, familiaAcolhedoraSA);
  }

  getFamiliaAcolhedoraSA(id, idSA) {
    return axios.get(API + path + `/${idSA}` + subPath + `/${id}`)
  }

  desligarFamiliaAcolhedoraSA(id, idSA, dataDesligamento) {
    return axios.post(API + path + `/${idSA}` + subPath + `/desligar/${id}`, {
      dataDesligamento
    });
  }
}

const instanceFamiliaAcolhedoraSA = new FamiliaAcolhedoraSAService();
export default instanceFamiliaAcolhedoraSA;